<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="4" right>呂善安君，你知道高賓閣跟賴和先生的關聯嗎？</npc>
              <npc :npc-id="0">⋯⋯1941年，總督府醫學校第二次同學會就是在高賓閣舉辦，賴和先生也有參加。不過，那已經是賴和先生的晚年——或許說是最後的時光也不為過。</npc>
              <npc :npc-id="1">1941年，已經是第二次世界大戰最激烈的時候了。</npc>
              <npc :npc-id="0">是啊，1941年12月，日軍偷襲珍珠港當天，日本警察毫無理由地拘捕賴和先生，他在獄中染上重病，之後因為病情太嚴重而出獄，詹作舟在這段期間舉辦了小逸堂的同學會，但賴和先生的病情一直沒有痊癒，隔年就在臺北醫院過世了。</npc>
              <npc :npc-id="4" right>沒錯。高賓閣是當時彰化的高級宴客場所，也見證了賴和先生的最後時光；謝謝你，呂善安，最後的『證明』已經完成了。</npc>

              <story-image :src="require(`@/assets/images/pics/第7章_3-1_高賓閣.jpg`)"></story-image>
              <!-- （照片：高賓閣） -->

              <npc :npc-id="0">林先生，差不多該好好解釋所謂的『證明』了吧？</npc>
              <npc :npc-id="4" right>當然。是這樣的，雖然我能在不同時空中移動，但這能力並沒有這麼方便，需要有人幫忙；透過其他人對歷史的觀察、詮釋，我才能接近自己想要前往的歷史，這也是我無法回到自己年代的原因——除了賴和先生的文字，沒有任何關於那個年代的證據。</npc>
              <npc :npc-id="0">原來如此，你一路上讓我探訪跟賴和先生有關的地點，就是為了讓你逼近某個時間點；林先生，你到底想去哪個時間帶？你的目的是什麼？</npc>
              <npc :npc-id="4" right>我要去1984年⋯⋯也就是現在；至於我的目的，則是恢復原有的歷史，讓賴和先生『被發現』。</npc>

              <story-image :src="require(`@/assets/images/pics/第7章_3-2_手稿.jpg`)"></story-image>
              <!-- （照片：手稿） -->

              <npc :npc-id="0">這⋯⋯這是！？</npc>
              <npc :npc-id="4" right>這是賴和先生的手稿。</npc>
              <npc :npc-id="0">賴和先生的手稿怎麼會在你手上？等等，你說這裡是1984年？難不成——</npc>
              <npc :npc-id="4" right>我要走了。只要有這個，歷史就會恢復原狀。</npc>
              <npc :npc-id="1">等一下！你怎麼能把我們放在這裡？我們要怎麼回到原來的時空？</npc>
              <npc :npc-id="4" right>放心，我將事情處理完，很快回來，到時候時空就會復原了。兩位，再會。</npc>
              <npc :npc-id="1">呂善安，你相信他嗎？</npc>
              <npc :npc-id="0">目前沒什麼好懷疑的。而且他說『原來的歷史』——我大概知道是怎麼回事了。</npc>
              <npc :npc-id="1">怎麼說？</npc>
              <npc :npc-id="0">原本我不是以為他來自α時空——也就是賴和先生默默無聞的時空嗎？恐怕我錯了，他跟我們來自同樣的時空。</npc>
              <npc :npc-id="1">什麼！？</npc>
              <npc :npc-id="0">歷史在我們不知情的情況下變動過，因此產生了α時空，要是什麼都不做，α時空會取代我們的時空成為正史吧？所以林先生才要採許行動。</npc>
              <npc :npc-id="1">你是說那些手稿？這是怎麼回事？</npc>
              <npc :npc-id="0">雖然現在我們很熟悉『臺灣新文學之父』這樣的稱號，但這其實不是理所當然的。在八〇年代以前，人們對賴和先生是很陌生的。</npc>
              <npc :npc-id="1">為什麼？賴和不是一直都在那裡嗎？</npc>
              <npc :npc-id="0">原本戰後臺灣文學就受到壓抑，戰前就過世的賴和先生，關於他的記憶也比較難留到現代。現在賴和先生之所以有這樣的地位，是因為臺灣文學研究者，也是文學館第一任館長林瑞明老師從作家楊逵先生那裡聽說賴和先生曾經用心培養他的事，才真正揭開了『賴和研究』的序幕。</npc>
              <npc :npc-id="1">原來如此，那些手稿就是研究材料嗎？</npc>
              <npc :npc-id="0">對，林瑞明老師拜訪賴和先生的家人好幾次，好不容易取得信任，才得到手稿；要是手稿不見了，『賴和研究』的樣貌一定會大不相同，這才造成α時空出現！</npc>

              <story-image :src="require(`@/assets/images/pics/第7章_3-3_平行世界圖表2.jpg`)"></story-image>
              <!-- （解說圖表3） -->

              <npc :npc-id="1">所以說，有人偷走了手稿，而林先生把手稿搶回來，透過呂善安的『證明』回到特定時間點，好將手稿還給被偷走的賴和家族，糾正歷史錯誤嗎？</npc>
              <npc :npc-id="0">是，而且偷走手稿的人恐怕就是——</npc>
              <npc :npc-id="1">啊！說到這個，既然林瑞明老師是第一任館長，難道這跟臺灣文學館消失有關？</npc>
              <npc :npc-id="0">不無可能⋯⋯恐怕還有更多原因吧？在蝴蝶效應之下，『賴和研究』的缺席造成臺灣文學館無法出現⋯⋯當然，具體原因已經無法得知了。</npc>
              <npc :npc-id="1">原來如此，那只要靜待林先生歸還手稿，世界就會恢復原狀了吧？</npc>
              <npc :npc-id="0">我想是的。雖然總覺得還有些不安因素——</npc>
              <npc :npc-id="3" right>譬如說我，對吧？</npc>

              <move-to-stage-btn link="警察追來了">警察居然追來了？！</move-to-stage-btn>

              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>
      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage7_3',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第七章 - 3',
      isQuestion: false,
      stageId: 'chaser',
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
